import { cn } from "@portal/components/lib/utils";
import { PartialIndicator, Text } from "@portal/components/primitives";
import type { ReactNode } from "react";

export const VIEW_SECTION_STICKY_HEADER_CLASS =
	"sticky top-0 z-[30] bg-surface-base border-b border-bc-subtle py-[10px] -mt-[10px]";

export type ViewSectionLayoutProps = {
	header: ReactNode;
	headerClassName?: string;
	button?: ReactNode;
	partial: boolean;
	partialActive: boolean;
	emptyMessage?: string;
	children: ReactNode;
	id?: string;
};

export const ViewSectionLayout = ({
	header,
	headerClassName,
	button,
	partial,
	partialActive,
	emptyMessage,
	children,
	id,
}: ViewSectionLayoutProps) => (
	<div id={id} className="flex flex-col w-full space-y-[20px]">
		<div
			className={cn("flex items-center justify-between w-full h-fit min-h-fit", headerClassName)}
		>
			<div className="flex items-center gap-x-[8px]">
				<Text type="title" color="primary" className="flex-1">
					{header}
				</Text>
				{partial && <PartialIndicator active={partialActive} className="mt-[1px]" />}
			</div>
			{button}
		</div>
		{children ||
			(emptyMessage !== undefined && (
				<Text type="caption" color="tertiary" className="italic">
					{emptyMessage}
				</Text>
			))}
	</div>
);
